import store from '@/store'
import { getData } from '@core/utils/http/general'

// Make http request to get info by asignature's id
export const materiaInfo = idMateria => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 2,
    materia: idMateria,
    token: store.state.cuenta.session.token,
  }

  getData(paramsRequest, 'wsmaterias')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        resolve({
          info: response.data.materia,
          modulos: response.data.modulos,
          seriaciones: response.data.seriaciones,
        })
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

// Make http request to get all asignatures
export const materiasList = () => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 1,
    token: store.state.cuenta.session.token,
  }

  getData(paramsRequest, 'wsmaterias')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) resolve(response.data.data)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

// Make http request to get all asignatures
export const departamentosList = () => new Promise((resolve, reject) => {
  getData({ action: 18 })
    .then(response => {
      if (response.status === 200 && response.data.status === 200) resolve(response.data.departamentos)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})
